import { motion, MotionValue } from 'framer-motion';
import React from 'react';

interface AnimatedLogoutIconProps {
  color: MotionValue<string>;
}

const AnimatedLogoutIcon: React.FunctionComponent<AnimatedLogoutIconProps> = ({ color }) => {
  return (
    <motion.svg width="14" height="16" viewBox="0 0 14 16" fill="none">
      <motion.path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 0C6.44772 0 6 0.447715 6 1V6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6V1C8 0.447715 7.55228 0 7 0ZM1.85025 12.7296C3.23183 14.2359 4.96429 14.9736 6.99937 15C7.06909 15 7.13995 15.0023 7.20901 15.0045C7.27465 15.0067 7.33866 15.0088 7.3985 15.0088C9.42481 14.8682 11.1003 14.0119 12.3853 12.4485C13.7801 10.749 14.245 8.78606 13.8503 6.62985C13.5959 5.2641 12.9687 4.08719 12.0038 3.08593C11.5213 2.58091 10.6617 2.66435 10.2976 3.26598C10.0345 3.70074 10.1046 4.24089 10.5038 4.66686C11.1924 5.40463 11.6222 6.26535 11.7625 7.26661C11.9424 8.53574 11.7099 9.73022 10.9687 10.7798C9.82394 12.4002 8.23183 13.0809 6.26253 12.8657C5.48622 12.7823 4.77569 12.5056 4.13973 12.0577C2.98183 11.2453 2.28885 10.1298 2.07832 8.72458C1.91166 7.58279 2.13534 6.51567 2.72306 5.5232C2.9056 5.21857 3.14026 4.9583 3.37481 4.69814C3.44458 4.62075 3.51433 4.54338 3.58271 4.46485C3.78885 4.22771 3.89411 3.95105 3.82832 3.63047C3.7406 3.20889 3.4906 2.92345 3.07832 2.79609C2.66165 2.66435 2.27569 2.7917 1.9906 3.08154C0.762532 4.32433 0.109023 5.83499 0.0125322 7.57401C-0.0971169 9.54139 0.512532 11.2716 1.85025 12.7296Z"
        fill={color}
      />
    </motion.svg>
  );
};

export default AnimatedLogoutIcon;
